import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from '@/api';
import {
    ActionLog,
    PaginatedResponse
} from '@/interfaces';

@Injectable({
    providedIn: 'root'
})
export class ActionLogsService {

    constructor(private apiService: ApiService) {
    }

    listing(params: Record<string, any>): Observable<PaginatedResponse<ActionLog>> {
        return this.apiService.get<any>('/action-logs', this.apiService.build(params)).pipe(
            map((res: any) => ({
                data: res.data,
                total: res.total,
                current_page: res.current_page,
                per_page: res.per_page
            }))
        );
    }

    export(params: Record<string, any>): Observable<Blob> {
        return this.apiService.postBlob('/action-logs/export', params);
    }

    autocomplete(field: 'action_code' | 'user.name', query: string, context: Record<string, any> = {}) {
        return this.apiService.get<string[]>(
            `/action-logs/autocomplete/${encodeURIComponent(field)}`,
            this.apiService.build({ q: query, ...context })
        );
    }
}
